import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import { Dashboard, Subscriptions, Projection, Tools, ExpenseTracker, Admin, Settings } from './pages';
import Login from './pages/Login';
import ChangePassword from './pages/ChangePassword';
import About from './pages/About';
import { useAuth } from './contexts/AuthContext';
import { LoadingSpinner } from './components/ui';

export default function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="h-screen bg-dark-900 flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/about" element={<About />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  if (user.mustChangePassword) {
    return <ChangePassword />;
  }

  const isFamilyMember = Boolean(user.isFamilyMember);

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={user.isRootAdmin ? <Admin /> : <Dashboard />} />
        <Route path="subscriptions" element={user.isRootAdmin ? <Admin /> : <Subscriptions />} />
        <Route path="projection" element={user.isRootAdmin ? <Admin /> : <Projection />} />
        <Route path="tools/todo" element={user.isRootAdmin ? <Admin /> : <Tools />} />
        <Route path="tools/expenses" element={user.isRootAdmin ? <Admin /> : <ExpenseTracker />} />
        <Route path="admin" element={isFamilyMember ? <Dashboard /> : <Admin />} />
        <Route path="settings" element={isFamilyMember ? <Dashboard /> : <Settings />} />
      </Route>
    </Routes>
  );
}
